import type { QueryClient } from "@tanstack/react-query";

/**
 * A reset, not an invalidation: the signed-out answers are wrong rather than stale, and half are
 * 401s an invalidation leaves in place - which is why the screen behind the sign-in form used to
 * say "Nog geen seizoen ingericht". Only sign-ins that stay on the page need it.
 */
export async function resetSession(queryClient: QueryClient) {
  await queryClient.resetQueries();
}
